/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserToJSONTyped,
} from './User';

/**
 * 
 * @export
 * @interface FuelUserItem
 */
export interface FuelUserItem {
    /**
     * 
     * @type {User}
     * @memberof FuelUserItem
     */
    user_info: User;
    /**
     * 
     * @type {number}
     * @memberof FuelUserItem
     */
    totalFuel: number;
}

/**
 * Check if a given object implements the FuelUserItem interface.
 */
export function instanceOfFuelUserItem(value: object): value is FuelUserItem {
    if (!('user_info' in value) || value['user_info'] === undefined) return false;
    if (!('totalFuel' in value) || value['totalFuel'] === undefined) return false;
    return true;
}

export function FuelUserItemFromJSON(json: any): FuelUserItem {
    return FuelUserItemFromJSONTyped(json, false);
}

export function FuelUserItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): FuelUserItem {
    if (json == null) {
        return json;
    }
    return {
        
        'user_info': UserFromJSON(json['user_info']),
        'totalFuel': json['totalFuel'],
    };
}

export function FuelUserItemToJSON(json: any): FuelUserItem {
    return FuelUserItemToJSONTyped(json, false);
}

export function FuelUserItemToJSONTyped(value?: FuelUserItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_info': UserToJSON(value['user_info']),
        'totalFuel': value['totalFuel'],
    };
}

